import { trackFormError } from "utils/analytics/trackEvent";
import { useGetHealthAppStepQuery } from "types/generated/operations";
import Error from "uicomponents/Error";
import Loader from "uicomponents/Loader";
import { getAppType } from "utils/helper";
import { isTestUser } from "utils/helper";
import NewHIApp from "pages/NewHealthInsuranceApp";
import HIApp from "pages/HealthInsuranceApplication";
import { getProspectUuid } from "utils/idHelpers";

const FindHIAppModel = () => {
  const appType = getAppType();
  const { data, error, loading } = useGetHealthAppStepQuery({
    variables: { uuid: getProspectUuid(), appType: appType },
    fetchPolicy: "no-cache",
    skip: !getProspectUuid() && !isTestUser,
  });

  if (loading || !data) {
    return <Loader />;
  }

  if (error) {
    trackFormError(error, `error getting ${appType} status`);
    return <Error />;
  }
  // old HI appication ->  version = nil
  // old HI appication -> in-progress app (app created before releasing v1)
  // new HI application -> version = v1
  // new HI appication -> no in-progress app

  // if feature flag turned on and if new application or application with version 1 -> show new app
  return data?.prospect?.applications?.length &&
    !data?.prospect?.applications?.[0]?.flowVersion ? (
    <HIApp />
  ) : (
    <NewHIApp />
  );
};

export default FindHIAppModel;
